import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcQuestionnaires = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 52 52"
    {...props}
  >
    <g>
      <path
        fill="#EEF4FF"
        d="M48 .952H4a4 4 0 0 0-4 4v44a4 4 0 0 0 4 4h44a4 4 0 0 0 4-4v-44a4 4 0 0 0-4-4Z"
      />
      <path
        fill="#5590FF"
        d="M31.3 43.952c1.7 0 3.09-.92 3.12-2.63v-1.34c.02-.35.3-.63.65-.64h3.5c.55 0 1-.45 1-1 0 0 0 2.3-2.67 4.31-1.6 1.17-3.53 1.35-5.51 1.36l-.09-.06Z"
        opacity={0.6}
      />
      <path
        fill="#D4E4FF"
        stroke="#5590FF"
        strokeLinejoin="round"
        d="M13.58 9.952c-.29 0-.57.11-.77.31-.2.2-.32.48-.32.77v31.84c0 .29.12.56.32.77.2.2.48.32.77.31H31.3c1.7 0 3.09-1.37 3.12-3.07v-1.33c0-.36.29-.64.65-.64h3.5c.55 0 1-.45 1-1v-26.88c0-.29-.12-.56-.32-.77-.2-.2-.48-.32-.77-.31h-24.9Z"
      />
      <path
        stroke="#5590FF"
        strokeLinecap="round"
        d="M39.57 37.992s.05 2.62-2.62 4.71c-1.6 1.21-3.55 1.25-5.53 1.25"
      />
      <path stroke="#5590FF" d="M16.42 38.952h9M16.42 40.952h5" />
      <path
        stroke="#5590FF"
        strokeLinecap="round"
        d="M27.88 14.852h7.44M26.35 17.622h8.97"
      />
      <path
        stroke="#5590FF"
        strokeLinejoin="round"
        d="M23.09 18.092v2.63h-6.67v-6.67h5.75"
      />
      <path
        stroke="#5590FF"
        strokeLinecap="round"
        d="M27.88 27.512h7.44M26.35 30.282h8.97"
      />
      <path
        stroke="#5590FF"
        strokeLinejoin="round"
        d="M23.09 26.952h-6.67v6.67h6.67v-6.67Z"
      />
      <path
        stroke="#5590FF"
        strokeLinecap="round"
        d="m18.46 16.382 1.67 2.38 5.29-5.19"
      />
    </g>
  </svg>
);
export default SvgIcQuestionnaires;
